/*
  Trailing cents off the compare-at price: 214.90 -> 214.

  Client-side by necessity, not by choice. These nodes carry .igPrice /
  .igComparePrice and Intelligems re-applies prices into them by variant id
  after render (see snippets/intelligems-variant-price-sync.liquid), so a value
  written in Liquid is overwritten - most visibly when a shopper switches
  currency, which is what makes the cents reappear.

  Previously this lived in the Intelligems "Pricing block redesign" test and
  died with it when the test ended. It belongs in the theme so it survives.

  Only the compare-at is touched. The price being charged is never rewritten.
*/
(function () {
  if (window.__priceDecimalStrip) return;
  window.__priceDecimalStrip = true;

  var SELECTOR = '.m-price-item--regular';
  // A decimal separator with exactly two digits after it, not part of a longer run.
  var CENTS = /(\d)[.,](\d{2})(?!\d)/g;

  var observer = null;
  var queued = false;

  function stripIn(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var next = node.nodeValue.replace(CENTS, '$1');
      if (next !== node.nodeValue) node.nodeValue = next;
    }
  }

  function run() {
    queued = false;
    // Detached while we write, or our own edits would re-trigger the observer.
    if (observer) observer.disconnect();
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i += 1) stripIn(els[i]);
    if (observer) observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || window.setTimeout)(run, 0);
  }

  function init() {
    observer = new MutationObserver(schedule);
    run();
    // IG can re-apply well after load (currency switch, price test); these catch it
    // before the observer would, on the paths that matter.
    [300, 800, 1500, 3000].forEach(function (t) { window.setTimeout(schedule, t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
